import { supportedLanguageCodes } from 'src/i18n/helpers';
import { countriesCodes } from 'src/i18n/localeHelpers';
import { type ContactInfo } from 'src/shared/components/HelpBar/types';

const defaultContactInfo: ContactInfo = {
  SUPPORT_CONTROL_PANEL_EMAIL_ADDRESS: 'soporte_empresas@payflow.es',
  INTEGRATION_EMAIL_ADDRESS: 'integrations@payflow.es',
  SUPPORT_EMAIL_ADDRESS: 'soporte_empresas@payflow.es'
};

const contactInfo = (languageCode: string): ContactInfo => {
  let countryContact;

  switch (languageCode) {
    case countriesCodes.spain:
    case supportedLanguageCodes.spain:
    case countriesCodes.france:
    case supportedLanguageCodes.france:
      countryContact = defaultContactInfo;
      break;
    case countriesCodes.portugal:
    case supportedLanguageCodes.portugal:
      countryContact = {
        SUPPORT_CONTROL_PANEL_EMAIL_ADDRESS: 'suporte_empresas@payflowapp.pt',
        INTEGRATION_EMAIL_ADDRESS: 'suporte_empresas@payflowapp.pt',
        SUPPORT_EMAIL_ADDRESS: 'suporte_empresas@payflowapp.pt'
      };
      break;
    case countriesCodes.colombia:
    case supportedLanguageCodes.colombia:
      countryContact = {
        SUPPORT_CONTROL_PANEL_EMAIL_ADDRESS: 'soporte_empresas@payflowapp.co',
        INTEGRATION_EMAIL_ADDRESS: 'soporte_empresas@payflowapp.co',
        SUPPORT_EMAIL_ADDRESS: 'soporte_empresas@payflowapp.co'
      };
      break;
    case countriesCodes.peru:
    case supportedLanguageCodes.peru:
      countryContact = {
        SUPPORT_CONTROL_PANEL_EMAIL_ADDRESS: 'soporte_empresas@payflowapp.pe',
        INTEGRATION_EMAIL_ADDRESS: 'soporte_empresas@payflowapp.pe',
        SUPPORT_EMAIL_ADDRESS: 'soporte_empresas@payflowapp.pe'
      };
      break;
    case countriesCodes.italy:
    case supportedLanguageCodes.italy:
      countryContact = {
        SUPPORT_CONTROL_PANEL_EMAIL_ADDRESS: 'soporte_empresas@payflow.es',
        INTEGRATION_EMAIL_ADDRESS: 'soporte_empresas@payflow.es',
        SUPPORT_EMAIL_ADDRESS: 'soporte_empresas@payflow.es'
      };
      break;
    default:
      countryContact = defaultContactInfo;
  }

  return countryContact;
};

export default contactInfo;
